import { datadogLogs, LogsEvent } from '@datadog/browser-logs'

import { ddLogs as ddLogsConfig } from 'embed/constants/config'
import { redactPossiblePiiParamsFromUrlObjectKeyValue } from '../utils'

datadogLogs.init({
  beforeSend(event: LogsEvent) {
    if (event.view) {
      redactPossiblePiiParamsFromUrlObjectKeyValue(event.view, 'referrer')
      redactPossiblePiiParamsFromUrlObjectKeyValue(event.view, 'url')
    }
    if (event.http) {
      redactPossiblePiiParamsFromUrlObjectKeyValue(event.http, 'url')
    }
  },
  ...ddLogsConfig,
})

export { datadogLogs }
